import { isLocalMachine } from "../../utils/api/controlProxy";

/**
 * Server cache TTL (ms) for homepage CMS batch (`withServerCache`).
 * Aligned with `PLP_CMS_BATCH_SERVER_CACHE_TTL_MS` in `plpApi/constants`.
 * @constant
 * @type {number}
 */
export const HOME_CMS_BATCH_SERVER_CACHE_TTL_MS = 600000;

/**
 * CMS batch gateway path keys for the homepage multi-path request (must match CMS paths).
 * @constant
 * @type {{ HOMEPAGE: string, APP_REDIRECT_BANNER: string, FREE_DELIVERY_BANNER: string }}
 */
export const HOME_CMS_BATCH_PATHS = {
  HOMEPAGE: "/homepage",
  APP_REDIRECT_BANNER: "/global/static/web/mobile/fnp_app_redirect",
  FREE_DELIVERY_BANNER: "/global/static/web/freedelivery",
};

/** Default `store` query value for homepage cms-batch when URL has no store slug. */
export const HOME_CMS_BATCH_DEFAULT_STORE = "fnp";

/**
 * Homepage CMS batch URL on the chocolate gateway (`NEXT_PUBLIC_CMS_SERVER_API_GATEWAY`).
 *
 * @param {string[]} pathsArray - Paths for repeated `paths=` query params
 * @param {string} [store] - Msite only: store slug from URL or default `fnp`; omitted on desktop
 * @returns {string} Relative URL for `/chocolate/v1/cms-batch/homepage`
 */
export const GET_HOME_CMS_BATCH_API_URL = (pathsArray, store) => {
  const pathsQuery = pathsArray.map((path) => `paths=${path}`).join("&");
  if (!store) {
    return `/chocolate/v1/cms-batch/homepage?${pathsQuery}`;
  }
  const storeQuery = `store=${encodeURIComponent(store)}`;
  return `/chocolate/v1/cms-batch/homepage?${pathsQuery}&${storeQuery}`;
};

/**
 * Builds batch API paths for the homepage.
 * Desktop: homepage CMS + free delivery banner.
 * Mobile: homepage CMS + app redirect banner (free delivery banner skipped on mobile home).
 * Menu is excluded — heavy and identical across pages, fetched client-side by `<Header>` instead.
 *
 * @param {Object} params
 * @param {boolean} params.isMobile
 * @returns {string[]}
 */
export const buildHomeBatchApiPaths = ({ isMobile }) => {
  return [
    ...(!isMobile ? [HOME_CMS_BATCH_PATHS.FREE_DELIVERY_BANNER] : []),
    ...(isMobile ? [HOME_CMS_BATCH_PATHS.APP_REDIRECT_BANNER] : []),
  ];
};

/**
 * Represents the API endpoint for masthead data
 * @constant
 * @type {string}
 */
export const GET_MASTHEAD_DATA = `/search/v1/homepage/masthead`;

/**
 * Represents the API endpoint for the dynamic home page feed (desktop).
 * @constant
 * @type {string}
 */
export const GET_HOME_FEED = `/search/v1/homepage/feed`;

/**
 * Represents the API endpoint for Gift Finder data in the website
 * @constant
 * @type {string}
 */
export const GET_APP_QUICK_SEARCH = `/chocolate/v1/global/static/app_quick_search`;
const baseUrl = isLocalMachine() ? "/control" : "/d/control";
/**
 *
 * @returns
 */
export const GET_PRODUCT_LIST = (
  FNP_CURRENT_CATALOG_ID = "india",
  catalogId = "india",
  pageType = "recentlyviewed",
  productIds = "COUR252085,COUR268951,ITNL335866,ITNL203269,ITNL418801,COUR269033,COUR269388,PERS2034",
) => {
  return `${baseUrl}/getProductListing-rj?FNP_CURRENT_CATALOG_ID=${FNP_CURRENT_CATALOG_ID}&catalogId=${catalogId}&pageType=${pageType}&productIds=${productIds}`;
};

/**
 * Returns the endpoint URL for fetching the product delivery time left.
 *
 * This function is used to get the API endpoint that provides the remaining time for a product delivery.
 *
 * @returns {string} The URL of the API endpoint to fetch the product delivery time left.
 */
export const getProductDeliveryTimeLeft = (productId, pincode) => {
  return `/control/getProductDeliveryTimeLeft${productId ? `?productId=${productId}&pincode=${pincode}` : ""}`;
};
